import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Estado } from '../../_models/estado';
import { EstadoCausal } from '../../_models/estado-causal';
import { NavService } from '../../_services/_nav.service';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { EstadoCausalService } from '../../_services/estado-causal.service';
import { ActivatedRoute, Params } from '@angular/router';
import { forkJoin } from 'rxjs';
import { ListaItem } from '../../_models/lista-item';
import { ListaService } from '../../_services/lista.service';
import { EstadoService } from '../../_services/estado.service';
import { Location } from '@angular/common';

@Component( {
  selector: 'app-estados-causal',
  templateUrl: 'estados-causal.component.html'
} )

export class EstadosCausalComponent implements OnInit {

  formulario: FormGroup;
  estado: Estado;
  cargando = true;
  lisEstadoCausalTodos: EstadoCausal[] = [];
  lisEstadoCausal: EstadoCausal[] = [];
  submitted = false;
  columnas: any[] = [];
  lisCausalesTodas: ListaItem[] = [];
  lisCausales: SelectItem[] = [];


  constructor( private navService: NavService,
               private conService: ConfirmationService,
               private estCausalService: EstadoCausalService,
               private lisService: ListaService,
               private route: ActivatedRoute,
               private estService: EstadoService,
               private location: Location,
               private fb: FormBuilder ) {
  }

  ngOnInit(): void {
    this.columnas = [
      { field: 'causalSolicitud', header: this.navService.buscarMensaje( 'ESTADOSCAUSAL.LBL_NOMBRECAUSAL' ), sort: false },
      { field: 'det', header: this.navService.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];

    this.route.params.subscribe( ( params: Params ) => {
      forkJoin( this.estCausalService.listadoPorEstado( params[ 'id' ] ),
        this.lisService.getMasterDetails( 'ListasCausalesSolicitudes' ),
        this.estService.obtenerPorId( params[ 'id' ] ) ).subscribe( ( [ lisEstadoCausal, lisCausales, estado ] ) => {
        this.estado = estado;
        this.lisCausalesTodas = lisCausales;
        this.lisEstadoCausalTodos = lisEstadoCausal;
        this.cargarEstadoCausales();
        this.cargarFormulario();
        this.cargarCausales();
        this.cargando = false;
      } );
    } );
  }

  cargarEstadoCausales() {
    this.lisEstadoCausal = this.lisEstadoCausalTodos.filter( x => x.indicadorHabilitado );
  }

  cargarCausales() {
    this.lisCausales = [];
    this.lisCausalesTodas.forEach( e => {
      if ( !this.lisEstadoCausal.find( x => x.idCausalSolicitud === e.idLista ) ) {
        this.lisCausales.push( { label: e.nombre, value: e.idLista } );
      }
    } );
  }

  cargarFormulario() {
    this.formulario = this.fb.group( {
      idCausales: [ [], [ Validators.required ] ]
    } );
  }

  onSubmit() {
    this.submitted = true;
    if ( !this.formulario.valid ) {
      return;
    }

    this.cargando = true;
    const registros = [];
    const registro = this.formulario.value;
    registro.idCausales.forEach( e => {
      const existe = this.lisEstadoCausalTodos.find( x => x.idCausalSolicitud === e );
      if ( existe ) {
        existe.indicadorHabilitado = true;
        registros.push( existe );
      } else {
        const a = {} as EstadoCausal;
        a.idCausalSolicitud = e;
        a.idEstado = this.estado.idEstado;
        a.indicadorHabilitado = true;
        const causal = this.lisCausalesTodas.find( x => x.idLista === e );
        if ( causal ) {
          a.causalSolicitud = causal.nombre;
          a.codigoCausalSolicitud = causal.codigo;
        }
        registros.push( a );
      }
    } );

    this.estCausalService.bulk( registros ).subscribe( respuesta => {
      registros.forEach( e => {
        if ( !e.idEstadoCausalSolicitud ) {
          const item = respuesta.find( x => x.idCausalSolicitud === e.idCausalSolicitud );
          if ( item ) {
            e.idEstadoCausalSolicitud = item.idEstadoCausalSolicitud;
          }
          this.lisEstadoCausalTodos.push( e );
        }
      } );
      this.reiniciarFormulario();
    } );

  }

  reiniciarFormulario() {
    this.submitted = false;
    this.cargarEstadoCausales();
    this.cargarCausales();
    this.cargarFormulario();
    this.formulario.markAsPristine();
    this.navService.setMesage( 2 );
    this.cargando = false;
  }

  regresar() {
    this.location.back();
  }

  get f() {
    return this.formulario.controls;
  }

  inhabilitar( registro: EstadoCausal ) {
    this.conService.confirm( {
      message: this.navService.buscarMensaje( 'MSG_INHABILITAR' ),
      header: this.navService.buscarMensaje( 'LBL_CONFIRMACION' ),
      icon: 'fa fa-question-circle',
      accept: () => {
        this.cargando = true;
        registro.indicadorHabilitado = false;
        this.estCausalService.actualizar( registro ).subscribe( regActualizado => {
          this.cargarEstadoCausales();
          this.cargarCausales();
          this.navService.setMesage( 2 );
          this.cargando = false;
        } );
      },
      reject: () => {
      }
    } );
  }


}
